import { useQuery } from '@apollo/client'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useState } from 'react'
import styled from 'styled-components'
import { ALL_LEADER_GROUPS_QUERY, Field } from '../../modules/companies'
import type { SelectMultipleOnSelectAll } from './SelectMultiple'
import { SelectMultiple } from './SelectMultiple'
import { SelectMultipleWrapper } from './SelectMultipleUsers'

const LeaderGroup = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;

  span.name {
    margin-left: 0.6rem;
  }
`

const SelectMultipleRelativeWrapper = styled.div<{ width: string }>`
  position: relative;
  width: ${props => props.width};
`

export interface SelectMultipleLeaderGroupsProps {
  selected: string[]
  onChange: (ids: string[]) => void
  compact?: boolean
  grayed?: boolean
  width?: string
  minWidth?: string
  error?: string | null
  onSelectAll?: SelectMultipleOnSelectAll
  isDirect?: boolean
}

export const SelectMultipleLeaderGroups: React.FC<
  SelectMultipleLeaderGroupsProps
> = ({
  selected,
  compact = true,
  width = '300px',
  minWidth,
  grayed = true,
  isDirect = false,
  error,
  onChange,
  onSelectAll,
  ...props
}) => {
  const [open, setOpen] = useState<boolean>(false)

  const translations = useTranslate({
    nLeaderGroups: ['users.n-groups', { n: 0 }],
    selectLeaderGroups: 'common.select-leader-groups',
  })

  const { data: leaderGroupsData } = useQuery(ALL_LEADER_GROUPS_QUERY)

  const leaderGroups = leaderGroupsData?.allLeaderGroups ?? []

  const options = leaderGroups.map(group => ({
    value: group.id,
    label: (
      <LeaderGroup>
        <span className="name">
          {group.name} ({group.usersCount})
        </span>
      </LeaderGroup>
    ),
  }))

  const selectedCount = selected.length
  const numSelectedText = translations.nLeaderGroups({ n: selectedCount })

  if (options.length === 0) {
    return null
  }

  return (
    <Field>
      {isDirect && <label>{translations.selectLeaderGroups}</label>}

      <SelectMultipleRelativeWrapper width={width}>
        <SelectMultipleWrapper
          open={open}
          numSelectedText={numSelectedText}
          compact={compact}
          width={width}
        >
          <SelectMultiple
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            selected={selected}
            options={options}
            onChange={onChange}
            searchable="custom"
            onSelectAll={onSelectAll}
            fullWidth
            grayed={grayed}
            error={error}
            minWidth={minWidth}
            {...props}
          />
        </SelectMultipleWrapper>
      </SelectMultipleRelativeWrapper>
    </Field>
  )
}
